import { render } from "./SidebarNavigation.vue?vue&type=template&id=1b724abc"
import script from "./SidebarNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarNavigation.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Layouts/SidebarNavigation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1b724abc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1b724abc', __exports__)) {
    api.reload('1b724abc', __exports__)
  }
  
  module.hot.accept("./SidebarNavigation.vue?vue&type=template&id=1b724abc", () => {
    api.rerender('1b724abc', render)
  })

}


export default __exports__